import { DatePicker, Form } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

import css from './css.module.less';

const EarliestShippingDateModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { onConfirm, onCancel, init, format } = props;

  const [form] = Form.useForm();

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days before today and today
    return current && current < moment().startOf('day');
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <Form
          form={form}
          initialValues={{
            earliestShippingDate: init,
          }}
          labelCol={{ span: 24 }}
          onFinish={onConfirm}
          className={css.earliestShippingDate}>
          <Form.Item
            name='earliestShippingDate'
            className={css.beforeDates}
            label={getI18n('allOrders.orderDetail.earliestShippingDate')}
            rules={[
              {
                required: true,
                message: replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  getI18n('allOrders.orderDetail.earliestShippingDate'),
                ),
              },
            ]}>
            <DatePicker
              format={format}
              size='large'
              disabledDate={disabledDate}
            />
          </Form.Item>
        </Form>
      </div>
      <ModalFooter
        okText={getI18n('general.antd.Modal.ModalFooter.confirm')}
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
      />
    </React.Fragment>
  );
};
export default EarliestShippingDateModal;
